/**
 * @param {{ link1?: string, link2?: string, link3?: string }} data
 * @returns {{ url: string }[]}
 */
export const iconLinksUtils = (data) => {
  return [
    { url: data.link1 || '#' },
    { url: data.link2 || '#' },
    { url: data.link3 || '#' },
  ];
};